/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Op_Started_HintInputs */



/**
* | output |
* | --- |
* | "It runs in the background — check the status panel above for the result." |
*
* @param {Admin_Op_Started_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_op_started_hint = /** @type {((inputs?: Admin_Op_Started_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Op_Started_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Elle s'exécute en arrière-plan — consultez le panneau de statut ci-dessus pour voir le résultat.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se ejecuta en segundo plano — consulte el panel de estado superior para ver el resultado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ela é executada em segundo plano — consulte o painel de status acima para ver o resultado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Viene eseguita in background — controlla il pannello di stato sopra per vedere il risultato.")
	return /** @type {LocalizedString} */ ("It runs in the background — check the status panel above for the result.")
});